import { createContext, useContext } from 'react'
import { PersonFragment } from '../../../types/graphql'

export const PersonContext = createContext({
    person: undefined,
    alreadySignedUp: false,
    setPerson: (person: PersonFragment) => {
        console.error('Context not implemented')
    },
    setAlreadySignedUp: (signedUp: boolean) => {
        console.error('Context not implemented')
    },
})
PersonContext.displayName = 'PersonContext'

export const usePerson = () => useContext(PersonContext)
